const VALID_PROTOCOLS = ['http:', 'https:'];

// Attempt to match what the back end does with net/url's `parse` method.
// It also does a protocol check, so we'll do that as well to avoid non-http protocols.
export default function isValidUrl(value?: string) {
  if (!value) {
    return false;
  }

  try {
    let url = new URL(value);
    return VALID_PROTOCOLS.includes(url.protocol);
  } catch {
    return false;
  }
}

// Validates that a given string is _potentially_ valid URL, i.e.
//
// 1. if it has http(s), then we just check if it is valid
// 2. otherwise, we prepend https and check if it is valid now
//
// This allows users to enter a value like `customer.io` without
// the protocol.
export function isPotentiallyValidUrl(value: string) {
  if (!value) {
    return false;
  }

  if (!VALID_PROTOCOLS.any((protocol) => value.includes(protocol))) {
    value = `https://${value}`;
  }

  return isValidUrl(value);
}
